// extracted by mini-css-extract-plugin
export default {"admin-sum-grid__wrapper":"SummaryGrid_admin-sum-grid__wrapper__xpFtw"};